import apiCreator from '../apiCreator'
import { CartItem } from '../../store/cart/types'
import { API_URL } from '../../constants/environment'

export type PostSpreadsheetRequest = {
  id: string;
  items: Array<CartItem>;
}

export type GenerateProposalSpreadsheetAsyncRequest = PostSpreadsheetRequest
export type GenerateProposalSpreadsheetAsyncResponse = {
  job_id: string;
}

export type RegenerateProposalSpreadsheetAsyncRequest = {
  id: string;
  sourceSpreadsheetId: string;
}
export type RegenerateProposalSpreadsheetAsyncResponse = {
  job_id: string;
}

type SpreadsheetApiType = {
  post: (request: PostSpreadsheetRequest) => Promise<string>,
  generateProposalSpreadsheetAsync:
  (request: GenerateProposalSpreadsheetAsyncRequest)
      => Promise<GenerateProposalSpreadsheetAsyncResponse>,
  regenerateProposalSpreadsheetAsync:
    (request: RegenerateProposalSpreadsheetAsyncRequest)
      => Promise<RegenerateProposalSpreadsheetAsyncResponse>,
}

export const spreadsheet: SpreadsheetApiType = {
  post: (request: PostSpreadsheetRequest): Promise<string> =>
    apiCreator
      .post<string>(
        `${API_URL.PROPOSALS}/proposal-spreadsheet`,
        request,
      )
      .then(({ data }) => data),
  generateProposalSpreadsheetAsync: request =>
    apiCreator
      .post<GenerateProposalSpreadsheetAsyncResponse>(
        `${API_URL.PROPOSALS}/proposal-spreadsheet-async`,
        request,
      )
      .then(({ data }) => data),
  regenerateProposalSpreadsheetAsync: ({
    id,
    sourceSpreadsheetId,
  }: RegenerateProposalSpreadsheetAsyncRequest): Promise<RegenerateProposalSpreadsheetAsyncResponse> =>
    apiCreator
      .post<RegenerateProposalSpreadsheetAsyncResponse>(
        `${API_URL.PROPOSALS}/proposal-spreadsheet-async`,
        {
          id,
          source_spreadsheet_id: sourceSpreadsheetId,
          mode: 'regenerate',
        },
      )
      .then(({ data }) => data),
}
